import component from './tasks.vue'

export default component
